import get from 'lodash/get';
import { storage } from './storage';
import { isNonEmptyString } from './isNonEmptyString';
import { DEFAULT_BRAND_LEAD_CHANNEL } from '../values/brand';

/**
 * Gets the lead channel from search params or local storage
 *
 * @returns {() => string}
 */
export const getAndSetLeadChannel = (
  getLeadChannelFromSearchParams = () =>
    new URL(get(window, 'location.href')).searchParams.get('leadChannel'),
  setLeadChannelInStorage = (value) => storage.set('leadChannel', value),
  getLeadChannelFromStorage = () => storage.get('leadChannel')
) => () => {
  const leadChannelFromSearchParams = getLeadChannelFromSearchParams();

  if (isNonEmptyString(leadChannelFromSearchParams)) {
    setLeadChannelInStorage(leadChannelFromSearchParams);
    return leadChannelFromSearchParams;
  }

  const leadChannelFromLocalStorage = getLeadChannelFromStorage();

  if (isNonEmptyString(leadChannelFromLocalStorage)) {
    return leadChannelFromLocalStorage;
  }

  setLeadChannelInStorage(DEFAULT_BRAND_LEAD_CHANNEL);
  return DEFAULT_BRAND_LEAD_CHANNEL;
};
